import {
  Stacktrace
} from '../../code';

export interface IStacktraceEvent {
  stacktrace?: Stacktrace
}
